// ListItem.js
import React, { useState } from "react";
import TarefasAtrasadas from "./Modules/DelayedTasksModule";
import FluxosAtrasados from "./Modules/DelayedFlowsModule";
import ColaboradoresAtrasados from "./Modules/DelayedWorkersModule";
import ChatReport from "./Modules/ChatModule";

const ListItem = ({ item, isEditing, remove, restore, isExcluded }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const renderContent = () => {
    const moduleProps = {
      item,
      isExpanded,
      toggleExpand,
      isEditing,
      remove,
      restore,
      isExcluded,
    };
    switch (item.type) {
      case "fluxos":
        return <FluxosAtrasados {...moduleProps} />;
      case "tarefas":
        return <TarefasAtrasadas {...moduleProps} />;
      case "colaboradores":
        return <ColaboradoresAtrasados {...moduleProps} />;
      case "ChatReport":
        return <ChatReport {...moduleProps} />;
      default:
        return null;
    }
  };

  return <div>{renderContent()}</div>;
};

export default ListItem;
